export async function getHoursPerWeek(token) {
    const url = `api/report/hours_per_week`;

    const response = await fetch(url,{
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch hours: ${response.status}`);
    }
    return response.json();
}